import { useHasAccess } from 'lib-shared-access-control';
import { SurveyInfo } from 'lib-shared-types-api';

import { AppLink } from 'components/appLink/appLink';

type SurveyLinkProps = {
  survey: SurveyInfo | null;
  surveyVersion: number | null;
};

/**
 * Renders a survey name as a link (if user has access and survey exists) or
 * plain text.
 */
export const SurveyLink = ({
  survey,
  surveyVersion,
}: SurveyLinkProps): JSX.Element => {
  const hasAccess = useHasAccess('settings.satisfaction');
  const surveyName = survey?.name ?? 'Unknown Survey';

  if (hasAccess && survey?.id) {
    return (
      <AppLink
        path="/settings/satisfaction/surveys/:surveyId"
        params={{ path: { surveyId: survey.id } }}
      >
        {surveyName}
        {surveyVersion ? ` (v${surveyVersion})` : ''}
      </AppLink>
    );
  }

  return <>{surveyName}</>;
};
